import { useEffect, useState } from 'react';
import {
  CLIENT_DEFAULT_INTEREST_SESSION_MODEL,
  INTEREST_SESSION_MODEL_TRI_GROUP
} from '../config/interestSessionConfig';

/**
 * Resolves which interest session algorithm the client should use.
 * Fetches server config when authenticated; falls back to client default.
 */
export function useInterestSessionModel() {
  const [sessionModel, setSessionModel] = useState(CLIENT_DEFAULT_INTEREST_SESSION_MODEL);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch('/api/interest-test/session-config');
        if (res.ok) {
          const data = await res.json();
          if (!cancelled && typeof data?.sessionModel === 'string') {
            setSessionModel(data.sessionModel);
          }
        }
      } catch {
        // keep client default
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return {
    sessionModel,
    loading,
    isTriGroup: sessionModel === INTEREST_SESSION_MODEL_TRI_GROUP
  };
}
